import { BullhornEntityTypes, BullhornNamespace, SalesforceNamespace } from 'datasource-service-lib';
import { InveniasEntityTypes, InveniasNamespace } from 'datasource-service-lib';
import { IEntity, INamedEntity, TemplateWorkflowConfig } from 'interfaces-lib';
import { EntitySelection } from '../template-workflow-types/templateworkflowcontext';

// this is a bit mad o_O

export type ShowEntitySelectionFn = (template: TemplateWorkflowConfig, entity: IEntity) => boolean;
export type SelectSourceEntitiesForAttachmentsFn = (entityDialogResult: EntitySelection, entity: INamedEntity) => INamedEntity[];

export class EntitySelectionPredicateFactory {
  public static get(namespace: string): ShowEntitySelectionFn {
    if (namespace === InveniasNamespace.name) {
      return (template: TemplateWorkflowConfig, entity: IEntity) => {
        const show = template.entity === InveniasEntityTypes.People && entity.type === InveniasEntityTypes.Assignments;
        console.debug(`Invenias.showEntitySelection(${template.entity}, ${entity.type})=${show}`);
        return show;
      };
    }

    if (namespace === BullhornNamespace.name) {
      return (template: TemplateWorkflowConfig, entity: IEntity) => {
        const show =
          (template.entity === BullhornEntityTypes.Candidate.toLowerCase() && entity.type === BullhornEntityTypes.JobOrder) ||
          (template.entity === BullhornEntityTypes.ClientContact.toLowerCase() && entity.type === BullhornEntityTypes.ClientCorporation) ||
          (template.entity === BullhornEntityTypes.JobSubmission.toLowerCase() && entity.type === BullhornEntityTypes.JobOrder);
        console.debug(`Bullhorn.showEntitySelection(${template.entity}, ${entity.type})=${show}`);
        return show;
      };
    }

    if (namespace === SalesforceNamespace.name) {
      return (template: TemplateWorkflowConfig, entity: IEntity) => {
        const show = Boolean(template.entity && entity.type && template.entity.toLowerCase() !== entity.type.toLowerCase());
        console.debug(`Salesforce.showEntitySelection(${template.entity}, ${entity.type})=${show}`);
        return show;
      };
    }

    throw new Error(`Unknown namespace '${namespace}'.`);
  }

  public static getSourceEntitiesForAttachments(namespace: string): SelectSourceEntitiesForAttachmentsFn {
    if (namespace === InveniasNamespace.name) {
      return (selectedEntity: EntitySelection, entity: INamedEntity) => [selectedEntity.source];
    }

    if (namespace === BullhornNamespace.name) {
      return (selectedEntity: EntitySelection, entity: INamedEntity) => {
        // why is this different for ClientCorporation
        return entity.type === BullhornEntityTypes.ClientCorporation ? [entity] : [selectedEntity.source];
      };
    }

    // @TODO: remove any hardcoded entities
    // mmahmoud: is this needed for SF?
    if (namespace === SalesforceNamespace.name) {
      return (entityDialogResult: EntitySelection, entity: INamedEntity) => {
        return entity.type?.toLowerCase() === 'account' ? [entity] : [entityDialogResult.source];
      };
    }
    throw new Error(`Unknown namespace '${namespace}'.`);
  }
}
